export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  CLIENTS: '/clients',
  REALTORS: '/realtors',
  EVENTS: '/events',
  REPORTS: '/reports',
  INVOICES: '/invoices',
  PAYMENTS: '/payments',
  BUSINESS: '/business',
  SETTINGS: '/settings',
  HELP: '/help',
  NOT_FOUND: '*',
};

export const PUBLIC_ROUTES = [ROUTES.LOGIN];

export const PROTECTED_ROUTES = [
  ROUTES.DASHBOARD,
  ROUTES.USERS,
  ROUTES.CLIENTS,
  ROUTES.REALTORS,
  ROUTES.EVENTS,
  ROUTES.REPORTS,
  ROUTES.INVOICES,
  ROUTES.PAYMENTS,
  ROUTES.BUSINESS,
  ROUTES.SETTINGS,
  ROUTES.HELP,
];
